import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

export class FileAge {
  label: string;
  days: number;
}

@Component({
  selector: 'app-file-age-restriction',
  templateUrl: './file-age-restriction.component.html',
  styleUrl: '../attachment-restrictions.component.scss',
  standalone: false
})
export class FileAgeRestrictionComponent {

  public static fileAgeOptions: FileAge[] = [
    { label: 'None', days: 0 },
    { label: '1 day', days: 1 },
    { label: '5 days', days: 5 },
    { label: '7 days', days: 7 },
    { label: '14 days', days: 14 },
    { label: '30 days', days: 30 },
    { label: '90 days', days: 90 },
    { label: '180 days', days: 180 },
    { label: '1 year', days: 365 },
    { label: '2 years', days: 730 },
  ];

  @Input() fileSection: any;

  fileAgeOptionsNonStatic = FileAgeRestrictionComponent.fileAgeOptions;

  get fileConfig(): FormGroup {
    return this.fileSection?.get('config') as FormGroup;
  }

  get fileFilters(): any {
    return this.fileConfig.get('filters');
  }
}
